import {CustomRequest} from "vendor/infrastructure/custom_requests";
import {CustomRequestV2} from "vendor/infrastructure/custom_requests_v2";
import {updateSending} from "vendor/application/disptach";

export class IntegrationsAPI {
    constructor(account_id, token, props, body) {
        this.account_id = account_id;
        this.token = token;
        this.props = props;
        this.body = body;

        this.props.dispatch(updateSending(true));
    }

    async get_channels() {
        let request = new CustomRequestV2("GET", `accounts/${this.account_id}/integrations`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_projects() {
        let request = new CustomRequestV2("GET", `accounts/${this.account_id}/projects`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_channel(integration_id) {
        let request = new CustomRequestV2("GET", `accounts/${this.account_id}/integrations/${integration_id}`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_app_integrations(integration_id) {
        let request = new CustomRequestV2("GET", `accounts/${this.account_id}/integrations/${integration_id}/apps/integrations`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_sunco_info() {
        let request = new CustomRequest("GET", "sunco", null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async post_integration() {
        const request = new CustomRequestV2("POST", `accounts/${this.account_id}/integrations`, JSON.stringify(this.body), this.token, this.props);
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_integration(integration_id) {
        const request = new CustomRequestV2("PUT", `accounts/${this.account_id}/integrations/${integration_id}`, JSON.stringify(this.body), this.token, this.props);
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_switchboard(integration_id) {
        const request = new CustomRequestV2("PUT", `accounts/${this.account_id}/integrations/${integration_id}/switchboard`, null, this.token, this.props);
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async delete_integration(integration_id) {
        let request = new CustomRequestV2("DELETE", `accounts/${this.account_id}/integrations/${integration_id}`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

}